import { Box } from "@mui/material";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { colors } from "../../../constants/colors";
import { MetaLabel, MetaValue } from "./announceView.style";
import { AnnounceMetaItem } from "./announceView.utils";

type Props = {
  items: AnnounceMetaItem[];
};

/** แถบข้อมูลย่อของประกาศ แบ่งช่องด้วยเส้นตั้ง (จอเล็กตัดเส้นออกแล้วเรียงลง) */
export default function AnnounceMetaStrip({ items }: Props) {
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap" }}>
      {items.map((item: AnnounceMetaItem, index: number) => (
        <Box
          key={`${item.label}-${index}`}
          sx={{
            flex: "1 1 200px",
            minWidth: 0,
            padding: "18px 24px",
            // ใช้ borderLeft แทน <Divider/> เพราะ custom.css บังคับ margin + สีเข้มด้วย !important
            borderLeft: {
              xs: "none",
              md: index === 0 ? "none" : `1px solid ${colors.black_08}`,
            },
          }}
        >
          <MetaLabel>{item.label}</MetaLabel>
          {item.isDate ? (
            <MetaValue
              sx={{
                color: colors.themeMainColor,
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <CalendarMonthOutlinedIcon sx={{ fontSize: 18 }} />
              {item.value}
            </MetaValue>
          ) : (
            <MetaValue>{item.value}</MetaValue>
          )}
        </Box>
      ))}
    </Box>
  );
}
